import PinDropOutlinedIcon from "@material-ui/icons/PinDropOutlined";
import { TrailerGpsProviderCreate } from "./TrailerGpsProviderCreate";
import { TrailerGpsProviderEdit } from "./TrailerGpsProviderEdit";
import { TrailerGpsProvidersList } from "./TrailerGpsProvidersList";

export default {
  icon: PinDropOutlinedIcon,
  list: TrailerGpsProvidersList,
  create: TrailerGpsProviderCreate,
  edit: TrailerGpsProviderEdit,
};
